import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, CalendarDays, HardHat } from "lucide-react";
import { api } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { StatusBadge } from "../StatusBadge";
import { JobDialog } from "../jobs/JobDialog";
import { Button } from "../ui/button";

export const QuoteJobCard = ({ quoteId, quoteStatus }) => {
  const [job, setJob] = useState(undefined);
  const [open, setOpen] = useState(false);
  useEffect(() => { if (quoteId) api.get("/jobs", { params: { quote_id: quoteId } }).then((r) => setJob(r.data[0] || null)); }, [quoteId]);
  if (!quoteId || job === undefined || (!job && quoteStatus !== "approved")) return null;

  return (
    <div className="rounded-lg border border-zinc-200 bg-white p-5" data-testid="quote-job-card">
      <div className="eyebrow mb-3">Job</div>
      {job ? (
        <div className="space-y-2 text-sm">
          <div className="flex items-center justify-between"><span data-testid="quote-job-number" className="font-mono font-semibold">{job.number}</span><StatusBadge status={job.status} testId="quote-job-status" /></div>
          <div className="flex items-center gap-2 text-zinc-600"><CalendarDays className="h-4 w-4 text-red-600" />{fmtDate(job.scheduled_date)}{job.scheduled_time && ` · ${job.scheduled_time}`}</div>
          <div className="flex items-center gap-2 text-zinc-600"><HardHat className="h-4 w-4 text-red-600" />{job.installer_name || "Unassigned"}</div>
          <div className="flex gap-2 pt-1">
            <Button data-testid="quote-job-edit" size="sm" variant="outline" onClick={() => setOpen(true)}>Edit job</Button>
            <Button data-testid="quote-job-view-all" size="sm" variant="ghost" asChild><Link to="/jobs">All jobs</Link></Button>
          </div>
        </div>
      ) : (
        <>
          <p className="mb-3 text-sm text-zinc-500">This quote is approved. Schedule the install and assign an installer.</p>
          <Button data-testid="create-job-button" className="w-full bg-zinc-900 hover:bg-zinc-800" onClick={() => setOpen(true)}><Wrench className="mr-2 h-4 w-4" />Create job</Button>
        </>
      )}
      <JobDialog open={open} onOpenChange={setOpen} job={job} quoteId={quoteId} onSaved={setJob} />
    </div>
  );
};
